const topics = [
  "装修增项",
  "二手车调表",
  "直播价格套路",
  "招聘押金",
  "医美分期",
  "低价旅游团",
  "保健品会销",
  "砍头息变体",
  "刷单控评",
  "教培退费",
  "招投标陪标",
  "健身房预付费",
  "渠道返点",
  "数据造假",
  "隐性扣费",
];

export default function TopicTicker() {
  return (
    <section className="w-full bg-foreground-950 border-y border-foreground-800 overflow-hidden">
      <div className="flex items-center">
        <div className="shrink-0 flex items-center gap-2 px-4 md:px-8 py-4 bg-primary-500 text-background-50">
          <i className="ri-broadcast-line text-lg" aria-hidden="true"></i>
          <span className="text-sm font-medium whitespace-nowrap">持续追踪话题</span>
        </div>
        <div className="relative flex-1 overflow-hidden py-4">
          <div className="flex w-max animate-marquee">
            {[0, 1].map((dup) => (
              <ul key={dup} className="flex items-center" aria-hidden={dup === 1}>
                {topics.map((topic) => (
                  <li
                    key={`${dup}-${topic}`}
                    className="flex items-center gap-3 px-6 text-sm text-background-100 whitespace-nowrap"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
                    {topic}
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}